import React, {useState} from 'react';
import { useMe } from "context/MeContext";
import { css } from '@emotion/react';
import { List } from "@pankod/refine-antd";
import "../../../App.scss"
import RouterProvider from "@pankod/refine-react-router-v6";
import { AdminCard } from 'components/AdminCard';
import { menuSystem} from "./menu-system.js"

const { Link } = RouterProvider;
export const MenuSystem: React.FC = () => {
  const { me } = useMe();
  const isSuperAdmin = me?.isOps;
  const filteredMenu = isSuperAdmin 
  ? menuSystem 
  : menuSystem.filter((item) => item?.title !== "Metadata");
  return (
    <List title={<h1 style={{fontSize: 35, marginTop:20, color:"rgb(4, 6, 10, 0.8)"}}>System Controls</h1>}>
      <div className="d2-grid" css={css`margin: 0 40px;`}>
        {/* card */}
        {menuSystem.map((item, index) => (
          <AdminCard
            key={index}
            url={item.url}
            icon={item.icon}
            title={item.title}
            description={item.description}
          />
        ))}
      </div>
    </List>
  );
};
